import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Form from 'deltoid/core/Form';
import { msToTime } from '@utils/common';

const Timer = ({
  interval, // in milli seconds
  onComplete,
  className,
}) => {
  const [timeLeft, setTimeLeft] = useState(interval);
  const [show, setShow] = useState(true);
  useEffect(() => {
    setTimeLeft(interval);
    if (interval>0) setShow(true);
  }, [interval]);

  useEffect(() => {
    if (timeLeft<=0) {
      onComplete();
      setShow(false);
      return;
    }
    const timer = setTimeout(() => {
      setTimeLeft(timeLeft-1000);
    }, 1000);
    // Clear timeout if the component is unmounted
    return () => clearTimeout(timer);
  });

  return (
    <>
      {
        show ? (
          <Form.Message type='muted' className={className}>{msToTime(timeLeft)}</Form.Message>
        ) : (
          <></>
        )
      }
    </>
  )
};

Timer.propTypes = {
  interval: PropTypes.number,
  onComplete: PropTypes.func,
  className: PropTypes.string,
};

Timer.defaultProps = {
  interval: 0,
  onComplete: () => {},
  className: '',
};

export default Timer;
